<template>
<div id="messagebox">
    <div class="main">
        <a-card size="small" style="width: 100%;">
            <template #title>
                <a-avatar :src="chatbot" />
                AIDI
            </template>
            <template #extra><a @click="closePanel()"><close-circle-two-tone /></a></template>
        </a-card>
        <message-panel></message-panel>
    </div>
</div>
</template>


<script>
import {
    CloseCircleTwoTone
} from '@ant-design/icons-vue';
import MessagePanel from '@/components/chatbot/MessagePanel';
import bg from "./images/bg.jpg"
import chatbot from "./images/chatbot.png"

export default {
  props: ["closePanel"],
  name: 'MessageBox',
  components: {
    MessagePanel,
    CloseCircleTwoTone
  },
  data() {
    return {
        bg: bg,
        chatbot: chatbot
    }
  }
}
</script>

<style lang="less" scoped>
#messagebox {
    margin: 0px auto;
    width:50%;
    height: 100%;
    position: fixed; bottom: 0; right: 10px;
    overflow: hidden;
    padding: 5px 5px 5px 5px;
    background: url('./images/bg.jpg');
    border-radius: 3px; 
    .sidebar, .main {
        height: 100%;
    }
    .sidebar {
        float: left;
        width: 200px;
        color: #f4f4f4;
        background-color: #2e3238;
    }
    .main {
        position: relative;
        overflow: hidden;
        background-color: #eee;
    }
    .text {
        position: absolute;
        width: 100%;
        bottom: 0;
        left: 0;
    }
    .message {
        height: 90%;
    }
}
</style>
